import { Field, FieldProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import { Grid } from '@mui/material';
import { Locale } from '@synergy/models';
import { PoolMarkdownEditor, PoolTextArea, PoolTypography } from '@synergy/components';
import { paloPrintedPosition } from '@synergy/components-palo';
import { useFormikContext } from 'formik';

import { PaloPrintCount } from '../../../../../../common/components/palo/palo-print-count';

export interface ProductDetailOverviewSectionDescriptionProps {
    selectedLanguage: Locale;
}

export const ProductDetailOverviewSectionDescription = (props: ProductDetailOverviewSectionDescriptionProps) => {
    // What a document prints of this article: the short description where
    // there is one, the long one otherwise — the same rule as in the position
    // dialog, so both say the same number (FRM-Z, #2225).
    const { values } = useFormikContext<{
        longDescription?: Record<string, string>;
        shortDescription?: Record<string, string>;
    }>();
    const printed = paloPrintedPosition(
        values.shortDescription?.[props.selectedLanguage],
        values.longDescription?.[props.selectedLanguage]
    );

    return (
        <>
            <PoolTypography styleType="sectionTitle" id="app.product.detail.articleDescription" />
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={12}>
                    <Field name={`longDescription.${props.selectedLanguage}`}>
                        {({ form, field }: FieldProps<string>) => (
                            <PoolMarkdownEditor
                                {...field}
                                value={field.value ?? ''}
                                onChange={value => form.setFieldValue(field.name, value)}
                            />
                        )}
                    </Field>
                    {!printed.isShort && printed.length > 0 && <PaloPrintCount length={printed.length} />}
                </Grid>
                <Grid item={true} xs={12}>
                    <Field name={`shortDescription.${props.selectedLanguage}`}>
                        {({ field }: FieldProps<string>) => (
                            <PoolTextArea
                                {...field}
                                value={field.value ?? ''}
                                label={<FormattedMessage id="app.label.shortDescription" />}
                                rows={5}
                            />
                        )}
                    </Field>
                    {printed.isShort && <PaloPrintCount length={printed.length} />}
                </Grid>
            </Grid>
        </>
    );
};
